import React from 'react';
export function TrustBar() {
  const logos = ['Keller Williams', 'eXp Realty', 'Coldwell Banker', 'RE/MAX', 'HomeSmart', 'West USA'];
  return <section className="bg-white py-8 border-b border-gray-100" data-id="element-197">
      <div className="container mx-auto px-4 md:px-6" data-id="element-198">
        <p className="text-center text-xs font-bold text-apex-charcoal/60 uppercase tracking-widest mb-6" data-id="element-199">
          Trusted By Phoenix Area Realtors And Brokerages
        </p>

        {/* Mobile: Horizontal scroll. Desktop: Flex wrap/center */}
        <div className="flex overflow-x-auto pb-4 md:pb-0 md:flex-wrap justify-start md:justify-center items-center gap-8 md:gap-16 snap-x hide-scrollbar" data-id="element-200">
          {logos.map((logo, index) => <div key={index} className="snap-center shrink-0 text-gray-400 font-extrabold text-xl md:text-2xl tracking-tighter grayscale opacity-60 hover:opacity-100 transition-opacity whitespace-nowrap" data-id="element-201">
              {logo}
            </div>)}
        </div>
      </div>
    </section>;
}